import React from 'react'

import {
  FeatureFlag,
  ResidentUserAuthLevel,
  User,
  UserMetadata,
} from '../../../common/validations'
import { useAPIGetUserMetadataSuspense } from '../../api/apiHooks/useAPIGetUserMetadata'
import { useAPIGetInvoiceAddressSuspense } from '../../api/apiHooks/useAPIGetInvoiceAddress'
import { InvoiceAddress } from '../../../common/validations/invoiceAddress'
import { useCurrentContract } from '../../hooks/useCurrentContract/useCurrentContract'
import { usePermissions } from '../../hooks/usePermissions'

import { useAPIGetUserProfileSuspense } from 'api/apiHooks/useAPIGetUserProfile'
import { useAPIGetFeatureFlagsSuspense } from 'api/apiHooks/useAPIGetFeatureFlags'

interface Data {
  user: User
  featureFlags: FeatureFlag
  userMetadata: UserMetadata
  invoiceAddress: InvoiceAddress | null
  authLevel: ResidentUserAuthLevel
  identificationRequired: boolean
}

export const DataLoader = ({
  children,
}: {
  children: (data: Data) => React.ReactNode
}) => {
  const { currentContractId } = useCurrentContract()
  const { data: user } = useAPIGetUserProfileSuspense()
  const { data: userMetadata } = useAPIGetUserMetadataSuspense()
  const { data: featureFlags } = useAPIGetFeatureFlagsSuspense()

  const { permissions, authLevel, identificationRequired } = usePermissions()
  const canViewBilling =
    permissions?.tenantRoles?.includes('payer') ||
    permissions?.tenantRoles?.includes('contractParty')

  const { data: invoiceAddress } = useAPIGetInvoiceAddressSuspense(
    currentContractId,
    { enabled: !!canViewBilling }
  )

  return children({
    user,
    featureFlags,
    userMetadata,
    invoiceAddress: invoiceAddress ?? null,
    authLevel,
    identificationRequired,
  })
}
